import { RootState } from "@/store/types";
import { ActionTree, Module } from "vuex";
import {HSCodeAssociationState} from "@/modules/hs_code_association/types";
import {deleteHSCodeAssociations, saveHSCodeAssociations} from "@/services/hs_code_asssociation";

const actions: ActionTree<HSCodeAssociationState, RootState> = {
  async SAVE_HS_CODE_ASSOCIATIONS(_, payload) {
    await saveHSCodeAssociations(payload)
  },
  async DELETE_HS_CODE_ASSOCIATIONS(_, itemIds) {
    await deleteHSCodeAssociations(itemIds)
  },
}

export const hs_code_associations: Module<HSCodeAssociationState, RootState> = {
  actions,
}
